const baseURL = 'https://217.77.13.31:8888';

export const login = async (userData) => {
    try {
      const response = await fetch(`${baseURL}/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      return data; 

    } catch (error) {
      throw error;
    }
};